export default __webpack_public_path__ + "static/media/insights-column.0ba20214.svg";